/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailabilityResponse
 */
export interface AvailabilityResponse {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponse
     */
    status: AvailabilityResponseStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof AvailabilityResponse
     */
    nextAvailabilityDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponse
     */
    workAvailability: AvailabilityResponseWorkAvailabilityEnum;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponse
     */
    frequency?: AvailabilityResponseFrequencyEnum;
}


/**
 * @export
 */
export const AvailabilityResponseStatusEnum = {
    AvailableAndVerified: 'AVAILABLE_AND_VERIFIED',
    Available: 'AVAILABLE',
    AvailableSoon: 'AVAILABLE_SOON',
    NotAvailableWithDate: 'NOT_AVAILABLE_WITH_DATE',
    NotAvailable: 'NOT_AVAILABLE'
} as const;
export type AvailabilityResponseStatusEnum = typeof AvailabilityResponseStatusEnum[keyof typeof AvailabilityResponseStatusEnum];

/**
 * @export
 */
export const AvailabilityResponseWorkAvailabilityEnum = {
    Partial: 'PARTIAL',
    FullTime: 'FULL_TIME',
    NotAvailable: 'NOT_AVAILABLE'
} as const;
export type AvailabilityResponseWorkAvailabilityEnum = typeof AvailabilityResponseWorkAvailabilityEnum[keyof typeof AvailabilityResponseWorkAvailabilityEnum];

/**
 * @export
 */
export const AvailabilityResponseFrequencyEnum = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    EveningsAndWeekends: 'EVENINGS_AND_WEEKENDS',
    FullTime: 'FULL_TIME'
} as const;
export type AvailabilityResponseFrequencyEnum = typeof AvailabilityResponseFrequencyEnum[keyof typeof AvailabilityResponseFrequencyEnum];


/**
 * Check if a given object implements the AvailabilityResponse interface.
 */
export function instanceOfAvailabilityResponse(value: object): value is AvailabilityResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('workAvailability' in value) || value['workAvailability'] === undefined) return false;
    return true;
}

export function AvailabilityResponseFromJSON(json: any): AvailabilityResponse {
    return AvailabilityResponseFromJSONTyped(json, false);
}

export function AvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'nextAvailabilityDate': json['nextAvailabilityDate'] == null ? undefined : (new Date(json['nextAvailabilityDate'])),
        'workAvailability': json['workAvailability'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
    };
}

export function AvailabilityResponseToJSON(value?: AvailabilityResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'nextAvailabilityDate': value['nextAvailabilityDate'] == null ? undefined : ((value['nextAvailabilityDate']).toISOString().substring(0,10)),
        'workAvailability': value['workAvailability'],
        'frequency': value['frequency'],
    };
}

